import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dayName'
})
export class DayNamePipe implements PipeTransform {

    private dayMap: Record<string, { en: string; ar: string }> = {
        sun: { en: 'Sunday', ar: 'الأحد' },
        mon: { en: 'Monday', ar: 'الاثنين' },
        tue: { en: 'Tuesday', ar: 'الثلاثاء' },
        wed: { en: 'Wednesday', ar: 'الأربعاء' },
        thu: { en: 'Thursday', ar: 'الخميس' },
        fri: { en: 'Friday', ar: 'الجمعة' },
        sat: { en: 'Saturday', ar: 'السبت' },
    };

    transform(value: string, lang: 'en' | 'ar' = 'en'): string {
        if (!value) return '';
        const key = value.trim().toLowerCase();
        const day = this.dayMap[key];
        return day ? day[lang] : value;
    }
}
